import { TranslocoPipe } from "@jsverse/transloco";
import { afterNextRender, ChangeDetectionStrategy, Component, computed, ElementRef, inject } from "@angular/core";
import { AnimationOptions, LottieComponent } from "ngx-lottie";

import { AccessibilityService } from "@azm/core/services/accessibility";
import { elevateToastOverlay } from "@azm/shared/utilities/overlay/toast-overlay.helpers";

@Component({
	selector: "azm-loading",
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [LottieComponent, TranslocoPipe],
	templateUrl: "./loading.html",
	styleUrl: "./loading.scss",
	host: { popover: "manual" },
})
export class Loading {
	readonly #host = inject<ElementRef<HTMLElement>>(ElementRef);
	readonly #accessibility = inject(AccessibilityService);

	readonly options = computed<AnimationOptions>(() => ({
		path: this.#loaderAssetPath(),
		loop: true,
	}));

	#loaderAssetPath(): string {
		switch (this.#accessibility.contrastMode()) {
			case "high":
				return "legalaffairs-loader-hc.json";
			case "grayscale":
				return "legalaffairs-loader-grayscale.json";
			default:
				return "legalaffairs-loader.json";
		}
	}

	constructor() {
		afterNextRender(() => {
			const host = this.#host.nativeElement as HTMLElement & { showPopover?: () => void };

			if (typeof host.showPopover === "function") {
				try {
					host.showPopover();
					elevateToastOverlay();
					return;
				} catch {}
			}

			host.removeAttribute("popover");
			host.classList.add("loading--inline");
			elevateToastOverlay();
		});
	}
}
